// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
module.exports = new Vue(require('../components/AppBase.js'));



// WEBPACK FOOTER //
// ./resources/assets/js/modules/App.js